export const ADD_PROCESS_REQUEST = 'ADD_PROCESS_REQUEST';
export const ADD_PROCESS_SUCCESS = 'ADD_PROCESS_SUCCESS';
export const ADD_PROCESS_FAIL = 'ADD_PROCESS_FAIL';
export const ADD_PROCESS_RESET = 'ADD_PROCESS_RESET';

export const GET_PROCESSES_REQUEST = 'GET_PROCESSES_REQUEST';
export const GET_PROCESSES_SUCCESS = 'GET_PROCESSES_SUCCESS';
export const GET_PROCESSES_FAIL = 'GET_PROCESSES_FAIL';
export const GET_PROCESSES_RESET = 'GET_PROCESSES_RESET';

export const UPDATE_PROCESS_REQUEST = 'UPDATE_PROCESS_REQUEST';
export const UPDATE_PROCESS_SUCCESS = 'UPDATE_PROCESS_SUCCESS';
export const UPDATE_PROCESS_FAIL = 'UPDATE_PROCESS_FAIL';
export const UPDATE_PROCESS_RESET = 'UPDATE_PROCESS_RESET';

export const DELETE_PROCESS_REQUEST = 'DELETE_PROCESS_REQUEST';
export const DELETE_PROCESS_SUCCESS = 'DELETE_PROCESS_SUCCESS';
export const DELETE_PROCESS_FAIL = 'DELETE_PROCESS_FAIL';
export const DELETE_PROCESS_RESET = 'DELETE_PROCESS_RESET';